<template>
  <div id="foundational-reports" class="section-container">
    <div class="d-flex justify-space-between">
      <header-title-two :loading="isLoading" title="Foundational Reports" loaderClass="mb-lg-4" />
      <template v-if="mapReports.length > 0">
        <previous-next-navigation
          :navIndex="reportsSlide"
          :navLast="mapReports.length - numberOfSlides"
          v-on:on-prev="onNav('prev')"
          v-on:on-next="onNav('next')"
          class-name="align-center prev-nav justify-end"
        />
      </template>
    </div>
    <skeleton-card-list
      type="avatar"
      :withoutMedia="true"
      :loading="isLoading"
      :isCard="true"
      :number="numberOfSlides"
      direction="horizontal"
      class="mt-4 skeleton-foundational-reports flex-nowrap flex-lg-wrap"
    >
      <div class="content">
        <slick-carousel
          v-if="mapReports.length > 0"
          ref="slickCarousel"
          :itemsToShow="numberOfSlides"
          :settings="slickSettings"
          @afterChange="afterChange"
        >
          <div
            class="content-item"
            v-for="(reports, i) in mapReports"
            v-bind:key="i"
          >
            <template v-for="item in reports" >
             <card-three :key="item.id" v-if="item.title && item.description" :data="item" />
            </template>
          </div>
        </slick-carousel>
      </div>
    </skeleton-card-list>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { FoundReportsApi } from '@gslc/models';
import { openApiConfig } from '../../api/config';

import HeaderTitleTwo from '../../components/typography/header-title-2.vue';
import PreviousNextNavigation from '../../components/PreviousNextNavigation.vue';
import SkeletonCardList from '../../components/skeleton/CardList.vue';
import CardThree from '../../components/cards/card-3.vue';
import SlickCarousel from '../../components/carousel/SlickCarousel.vue';
import { defaultSlickSettings, getNumberOfSlides } from '../../utils/carousel';

const config = openApiConfig();
const foundReportsApi = new FoundReportsApi(config);

export default {
  components: {
    HeaderTitleTwo,
    PreviousNextNavigation,
    SkeletonCardList,
    CardThree,
    SlickCarousel,
  },
  data: () => ({
    reportsSlide: 0,
    isLoading: false,
    slickSettings: defaultSlickSettings([2, 4, 3, 2, 1.2]),
  }),
  computed: {
    ...mapGetters(['reports', 'windowWidth']),
    numberOfSlides () {
      return getNumberOfSlides(this.windowWidth, [1.2, 2, 3, 4, 2]);
    },
    mapReports() {
      let currentReports = JSON.parse(JSON.stringify(this.reports));
      let newArrReports = [];
      if (this.reports && this.reports.length) {
        while (currentReports.length) {
          newArrReports.push(currentReports.splice(0, 2));
        }
      }
      if (this.windowWidth < 1264) {
        newArrReports = [];
        currentReports = JSON.parse(JSON.stringify(this.reports));
        while (currentReports.length) {
          newArrReports.push(currentReports.splice(0, 1));
        }
      }
      return newArrReports;
    },
  },
  mounted() {
    this.fetchFoundReports();
  },
  methods: {
    ...mapActions(['refreshFoundReports']),
    async fetchFoundReports() {
      this.isLoading = true;
      const accessToken = await this.$auth.getTokenSilently();
      const foundReports = await foundReportsApi
        .getFoundationalReports({
          headers: { Authorization: `Bearer ${accessToken}` },
        })
        .catch(e => console.error(e));
      this.refreshFoundReports(foundReports?.data?.data ?? []);
      this.isLoading = false;
    },
    afterChange(slideNumber) {
      this.reportsSlide = slideNumber;
    },
    onNav(type) {
      switch (type) {
        case 'prev':
          this.$refs.slickCarousel.$children[0].prev();
          break;
        case 'next':
        default:
          this.$refs.slickCarousel.$children[0].next();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  margin-left: -8px;
  padding-left: 8px;
  width: calc(100% + 16px);

  margin-left: -8px;
  padding-left: 8px;
  width: calc(100% + 16px);

  &-item {
    display: flex !important;
    flex-direction: column;
    row-gap: 16px;
    width: calc(50% - 18px);
    @media (max-width: 1263px) {
      width: initial;
    }
  }
}
</style>
